import { render } from "./copyTableButton.vue?vue&type=template&id=466a1501"
import script from "./copyTableButton.vue?vue&type=script&lang=js"
export * from "./copyTableButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__